/** @format */

import dynamic from "next/dynamic";
import { Layout } from "../components/common/Layout";
import Spinner from "../components/Spinner/Spinner";

const DynamicTipsToReduceCosts = dynamic(
  () => import("../components/FreightCosts/FreightCosts"),
  {
    ssr: false,
    loading: () => <Spinner />,
  }
);

export default function FreightCostsPage() {
  const meta = {
    title:
      "Tips to optimize your costs",
    description:
       "Tips and tricks as you think about building your order assortment that will help reduce or minimise your  freight cost per unit.",
    keywords:
      "handmade, fair trade, wholesale buying, global sourcing, Indian crafts, Exporters from India, Verified manufacturers and suppliers, B2B platform",
    url: "/tips_to_reduce_costs",
  };

  return (
    <Layout meta={meta}>
      <>
        <DynamicTipsToReduceCosts />
      </>
    </Layout>
  );
}
